<template>
    <div class="profile">
        <v-container>
            <v-col>
                <UserStats :userHash="userHash" />
            </v-col>
            <v-col>
                <RecentGames :isPowerPuzzle="false" :userHash="userHash" />
            </v-col>
            <v-col>
                <RecentGames :isPowerPuzzle="true" :userHash="userHash" />
            </v-col>
        </v-container>
    </div>
</template>

<script>
/* eslint-disable */
import Avatar from "@/components/Avatar.vue";
import axios from "axios";
import moment from "moment";
import RecentGames from "@/components/Profile/RecentGames.vue";
import UserStats from "@/components/Profile/UserStats.vue";

export default {
    name: "Profile",
    props: ["userHash", "authenticated"],
    components: { Avatar, RecentGames, UserStats }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-header {
    text-align: center;
    margin-bottom: 20px;
}

.section-container {
    display: flex;
    justify-content: space-around;
}
</style>

